function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2182 0.000188324C12.0169 0.00515821 11.8251 0.0896452 11.6855 0.235261L6.49987 5.42077L1.31428 0.235261C1.17016 0.0871603 0.972851 0.00416418 0.766601 0.00416418C0.455983 0.00466113 0.176675 0.193017 0.0598822 0.48077C-0.0569102 0.768523 0.0121712 1.09802 0.234822 1.31471L5.42041 6.50022L0.234822 11.6857C0.0355297 11.8771 -0.0449825 12.1613 0.024596 12.4292C0.0946714 12.6966 0.303407 12.9053 0.570787 12.9754C0.838664 13.045 1.12294 12.9645 1.31428 12.7652L6.49987 7.57967L11.6855 12.7652C11.8768 12.9645 12.1611 13.045 12.4289 12.9754C12.6963 12.9053 12.9051 12.6966 12.9751 12.4292C13.0447 12.1613 12.9642 11.8771 12.7649 11.6857L7.57933 6.50022L12.7649 1.31471C12.992 1.09653 13.0626 0.761565 12.9413 0.470334C12.8206 0.179599 12.5333 -0.00676937 12.2187 0.000188324H12.2182Z",
  fill: "#656565"
});

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.e85b0320.svg";
export { ForwardRef as ReactComponent };